function totalTilesPerPage(isLastLoad = false) {
  const marketing_tiles = document.querySelectorAll("[injected]");
  let marketingTilesLength = marketing_tiles?.length || 0;

  const products_on_page = document.getElementById("product-grid");
  const items_per_page = products_on_page.dataset.itemsPerPage
  const productsOnPageLength = products_on_page.children.length;
  const total_cards_on_page = products_on_page.children.length;


  const makeVisible = {
    from: productsOnPageLength - marketingTilesLength - items_per_page,
    to: productsOnPageLength - marketingTilesLength,
  }

  for (let i = makeVisible.from; i < makeVisible.to; i++) {
    if (products_on_page.children[productsOnPageLength - i]?.style) products_on_page.children[i].style.display = "block";
  }

  if (!isLastLoad && total_cards_on_page > items_per_page) {
    //takes out the excess of tiles displayed
    for (let i = marketingTilesLength; i > 0; i--) {
      if (products_on_page.children[productsOnPageLength - i]?.style) products_on_page.children[productsOnPageLength - i].style.display = "none";
    }
  }
}
totalTilesPerPage();
